import { useEffect, useState } from "react";
import { CounterInputEdit } from "../../../EditOnboarding/components/Input/CounterInput/Index";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";

interface InfoSoilPreparationProps {
  task: ITaskSoilPreparation | undefined;
}


export default function InfoSoilPreparation(task: InfoSoilPreparationProps) {
  const [taskSoilPreparation, setTaskSoilPreparation] = useState<ITaskSoilPreparation>();
  useEffect(() => {
    setTaskSoilPreparation(task.task)
  }, []);


  return (
    <>
      <div >
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSoilPreparation?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi iniciada?`} pointed />
        <ButtonYesOrNo onlyResult optionSelected={taskSoilPreparation?.initial_hour_meter ? "yes" : "no"} />
      </div>

      {!taskSoilPreparation?.initial_hour_meter ?
        taskSoilPreparation?.skip_reason ? <MessageBalloon text={`${taskSoilPreparation?.skip_reason}`} pointed /> : <></>
        :
        <>
          <MessageBalloon text={`${format(new Date(taskSoilPreparation?.start_time || 0), 'dd/MM/yyyy - HH:mm')}`} />

          <MessageBalloon text={`Informar horímetro inicial`} />
          <CounterInputEdit isDisabled defaultValue={taskSoilPreparation?.initial_hour_meter || 0} control={undefined} isInline label="h" />


          <ButtonPressed onlyResult optionSelected={1} value={1} text={`Horímetro final`} />

          <MessageBalloon text={`${format(new Date(taskSoilPreparation?.end_time || 0), 'dd/MM/yyyy - HH:mm')}`} />

          <MessageBalloon text={`Informar horímetro final`} />
          <CounterInputEdit isDisabled defaultValue={taskSoilPreparation?.final_hour_meter || 0} control={undefined} isInline label="h" />
        </>
      }
    </>
  )
}